<template>
    <div class="container" style="margin: 0">
        <div class="row mb-2">
            <select class="form-control col-md-3" v-model="myValue.city_id">
                <option v-for="city in cities" :key="city.id" :value="city.id">
                    {{ city.name_of }}
                </option>
            </select>
            <select class="form-control col-md-3" v-model="myValue.dist_id">
                <option v-for="dist in dists" :key="dist.id" :value="dist.id">
                    {{ dist.name_of }}
                </option>
            </select>
            <input
                type="text"
                class="form-control col-md-6"
                placeholder="地址"
                v-model="myValue.road"
            />
        </div>
        <div class="row mb-2">
            <input
                type="text"
                class="form-control"
                :value="pathResult"
                readonly
            />
        </div>
    </div>
</template>
<script>
    import Axios from "axios";
    import ComponentAPIVue from "../ComponentAPI.vue";

    export default {
        extends: ComponentAPIVue,
        props: {
            value: {
                default() {
                    return this.defaultValue();
                },
            },
        },
        watch: {
            value: {
                deep: true,
                handler(newValue, oldValue) {
                    this.myValue = this.cloneVar(newValue, true);
                    this.syncData();
                },
            },
            myValue: {
                deep: true,
                handler(newValue, oldValue) {
                    let result = Object.keys(newValue).filter((key) => {
                        return (
                            (!this.value[key] && !!newValue[key]) ||
                            this.value[key] !== newValue[key]
                        );
                    });
                    if (result.length) this.$emit("input", this.myValue);
                    this.syncData();
                },
            },
        },
        data() {
            return {
                previous: {
                    city_id: undefined,
                    dist_id: undefined,
                },
                myValue: {},
                cities: [],
                dists: [],
            };
        },
        mounted() {
            this.myValue = Object.assign(
                {},
                this.defaultValue(),
                this.cloneVar(this.value, true)
            );
            this.loadCities();
        },
        methods: {
            defaultValue() {
                return {
                    city_id: undefined,
                    dist_id: undefined,
                    road: undefined,
                };
            },
            apiGet(url) {
                return this.apiFormatOutput(Axios.get(url));
            },
            loadCities() {
                this.apiGet(`${base_url}/api/regions/cities`).then((cities) => {
                    this.cities = cities;
                    if (!this.myValue.city_id && this.cities.length) {
                        this.myValue.city_id = this.cities[0].id;
                        this.loadDists();
                    }
                });
            },
            loadDists() {
                console.log("load dists", this.myValue.city_id);
                this.apiGet(
                    `${base_url}/api/regions/${this.myValue.city_id}/dists`
                ).then((dists) => {
                    this.dists = dists;
                    if (this.dists.length) {
                        let included =
                            this.dists
                                .map((dist) => dist.id)
                                .indexOf(this.myValue.dist_id) !== -1;
                        console.log(
                            included,
                            this.dists.map((dist) => dist.id)
                        );
                        if (!included) this.myValue.dist_id = this.dists[0].id;
                    }
                });
            },
            syncData() {
                let { city_id, dist_id } = this.myValue;
                if (!!city_id && city_id !== this.previous.city_id) {
                    this.loadDists();
                }
                this.previous.city_id = city_id;
                this.previous.dist_id = dist_id;
            },
        },
        computed: {
            pathResult() {
                let cities = this.cities.filter(
                        (city) => city.id === this.myValue.city_id
                    ),
                    city = cities.length ? cities[0].name_of : "",
                    dists = this.dists.filter(
                        (dist) => dist.id === this.myValue.dist_id
                    ),
                    dist = dists.length ? dists[0].name_of : "",
                    zip_code =
                        dists.length && dists[0].zip_code ? dists[0].zip_code : "",
                    road = this.myValue.road ?? "";
                return `${zip_code} ${city}${dist}${road}`;
            },
        },
    };
</script>
<style>
</style>